/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {StartWebAuthnAuthenticationRequest} from '@cash-web/protos/squareup/cash/janus/api/WebAuthn.pb'
import {StartWebAuthnAuthenticationResponse} from '@cash-web/protos/squareup/cash/janus/api/WebAuthn.pb'


export const startWebAuthnAuthentication = (request:StartWebAuthnAuthenticationRequest, options?: CashRequestOptions) => post<StartWebAuthnAuthenticationRequest, StartWebAuthnAuthenticationResponse>("/cash-app/security/1.0/start-webauthn-authentication", request, {...options, rejectOnError: true })